import BaseApi from '../BaseApi';
import { AuthConverter } from './AuthConverter';

class AuthApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/user`;
    this.baseUrl2 = `${baseUrl}/api`;
    this.converter = new AuthConverter();
  }

  signInByEmail = (email, password) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/login/email`, { email, password });

  signIn = (login, password) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/login`, { username: login, password: password });

  checkAuth = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/check`, null, null, this.converter.convertUserData);

  getBalance = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/balance`, null, null, this.converter.convertBalance);

  getMetadata = () =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/metadata`, null, null, this.converter.convertMetadata);

  logOut = () => this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/logout`);

  changePassword = (pass, code) => {
    return this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/password/restore/new`, {
      code: code,
      new_password: pass,
    });
  };

  toggleSemiAutoWithdrawalEnabled = ({ semi_auto_withdrawal_enabled }) =>
    this.sendQuery(
      this.queryTypes.PATCH,
      `${this.baseUrl2}/agent_admin/payment/requests/change/semi_auto_withdrawal`,
      {
        semi_auto_withdrawal: semi_auto_withdrawal_enabled,
      },
      null,
      data => data.semi_auto_withdrawal_enabled,
    );

  toggleHigherAgentsOperationsRestricted = ({ is_higher_agents_operations_restricted }) =>
    this.sendQuery(
      this.queryTypes.PATCH,
      `${this.baseUrl2}/agent_admin/payment/requests/change/higher_agents_operations`,
      { is_higher_agents_operations_restricted },
    );
}

export default AuthApi;
